import React from 'react';
import DescribeActivityContainer from './DescribeActivityContainer';
import {
  TrackerEstimateBurnedCaloriesConnectorApollo,
  withMobileAppMode,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const DescribeActivityPage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <TrackerEstimateBurnedCaloriesConnectorApollo>
        {({ estimateBurnedKcals, cancelEstimateBurnedKcals }) => (
          <DescribeActivityContainer
            estimateBurnedKcals={estimateBurnedKcals}
            cancelEstimateBurnedKcals={cancelEstimateBurnedKcals}
            key={location.key} // Force re-render
          />
        )}
      </TrackerEstimateBurnedCaloriesConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(DescribeActivityPage);
